import Cookies from "universal-cookie";
import { create } from "apisauce";
import { displayToast } from "../components/shared/toast/toastUtils";

export const loginClient = create({
  baseURL: process.env.REACT_APP_AUTH_API_BASE_URL,
});

const cookies = new Cookies();
const getToken = async () => {
  try {
    return await cookies.get("access_token");
  } catch (e) {
    console.log("Error getting access token: " + e);
  }
};

loginClient.addAsyncRequestTransform(async (request) => {
  const authToken = await getToken();

  if (!authToken) return;

  request.headers["Authorization"] = `Bearer ${authToken}`;
  request.headers["Content-Type"] = "application/json";

  return request;
});

loginClient.addResponseTransform(
  (response) => {
    if (response.status === 401) {
      cookies.remove("access_token");
      cookies.remove("refresh_token");
      localStorage.clear();
      window.location.href = "/login";
      // alert("Session is Expired");
      displayToast({
        type: "error",
        title: "Session expired. Please log in again.",
      });
      return;
    }
  },
  () => {
    console.log("Token Invalid");
  },
);

const authClient = create({
  baseURL: process.env.REACT_APP_LEADS_API_BASE_URL,
});

authClient.addAsyncRequestTransform(async (request) => {
  const authToken = await getToken();
  console.log("auth token", authToken);
  if (!authToken) {
    return;
  }
  request.headers["Authorization"] = "Bearer " + authToken;
  // request.headers["Content-Type"] = "multipart/form-data";
  request.headers["Content-Type"] = "application/json";
  // request.headers["Accept"] = "*/*";
  // if not working remove return
  return request;
});

authClient.addResponseTransform(
  (response) => {
    if (response.status === 401) {
      cookies.remove("access_token");
      cookies.remove("refresh_token");
      localStorage.clear();
      window.location.href = "/login";
      // alert("Session is Expired");
      displayToast({
        type: "error",
        title: "Session expired. Please log in again.",
      });
      return;
    }
  },
  () => {
    console.log("Token Invalid");
  },
);

export default authClient;
